// src/store/mappers/notifications/index.ts

import type { NotificationItemDTO, NotificationsPayloadDTO } from '@/types/NotificationDTOs';
import type { NotificationItem, Notifications } from '@/types/UserState';

/**
 * Maps a single notification item DTO to FE model
 */
export function mapNotificationItemDTOToNotificationItem(dto: NotificationItemDTO): NotificationItem {
  return {
    id: dto.id,
    type: dto.type,
    actor: {
      id: dto.actor.id,
      name: dto.actor.name,
    },
    six: {
      id: dto.six.id,
      name: dto.six.name,
    },
    action: dto.action,
    target: dto.target,
    read: dto.read,
    createdAt: new Date(dto.createdAt),
  };
}

/**
 * Maps the full notifications payload DTO to FE model
 */
export function mapNotificationsPayloadDTOToNotifications(dto: NotificationsPayloadDTO): Notifications {
  return {
    items: dto.map(notification => mapNotificationItemDTOToNotificationItem(notification)),
    unreadCount: dto.filter(notification => !notification.read).length,
    // pagination: mapPaginationDTOToPagination(dto.pagination),
  };
}
